// import data from "../static-data.json";

const Projects2 = ({ data }) => {
  return (
    <div className="vg-page page-portfolio" id="portfolio">
      <div className="line">
        <h2 className="text-center fw-normal wow fadeIn">My Projects</h2>
        <div className="margin">
          {data.projects.map((project, idx) => (
            <div className="s-12 m-6 l-6 my-2" key={idx}>
              <div className="s-12 l-2">
                <div className="news-date">
                  <p className="month">{project.startDate} - {project.endDate}</p>
                </div>
              </div>
              <div className="s-12 l-10">
                <div className="news-text">
                  <h4>{project.projectName}</h4>
                  <p
									style={{
										display: "block",
										maxHeight: "5em",
										overflow: "hidden",
										textOverflow: "ellipsis",
									}}
								>
									{project.description}
								</p>
                  {project.projectLink && (
                  <a
                    href={project.projectLink}
                  >
                    SEE LIVE DEMO
                  </a>
                )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects2;
